import React, { useState } from 'react';
import { Button, TextField, Typography, Container, IconButton, InputAdornment, Box } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';

export const FundiIdUpload = () => {
    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState('');
    const [uploadSuccess, setUploadSuccess] = useState(false);

    const fileInputRef = React.useRef(null);

    const handleFileChange = (event) => {
        if (event.target.files.length > 0) {
            const selectedFile = event.target.files[0];
            setFile(selectedFile);
            setFileName(selectedFile.name);
        }
    };

    const triggerFileInput = () => {
        fileInputRef.current.click();
    };

    const handleUpload = async () => {
        if (!file) {
            alert('Please select a file first!');
            return;
        }

        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await fetch('api', {
                method: 'POST',
                body: formData,
            });

            if (response.ok) {
                setUploadSuccess(true);
                setFile(null);
                setFileName('');
            } else {
                throw new Error('Failed to upload file');
            }
        } catch (error) {
            console.error('Error uploading file:', error);
            alert(error.message);
        }
    };

    return (
        <Box maxWidth="sm" sx={{ mt: 5, }}>
            <Typography variant="h6" gutterBottom sx={{ textAlign: 'left' }}>
                ID Proof
            </Typography>
            <Box>
                <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                />
                <TextField
                    placeholder="Select a file..."
                    value={fileName}
                    onClick={triggerFileInput}
                    fullWidth
                    sx={{ mb: 2 }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={triggerFileInput} color="primary">
                                    <AttachFileIcon />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
            </Box>
            <Box textAlign="right">
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleUpload}
                    disabled={!file}
                >
                    Upload
                </Button>
            </Box>
            {uploadSuccess && (
                <Typography color="success.main" sx={{ mt: 2 }}>
                    File uploaded successfully!
                </Typography>
            )}
        </Box>
    );
};

export const FundiCertiUpload = () => {
    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState('');
    const [uploadSuccess, setUploadSuccess] = useState(false);

    const fileInputRef = React.useRef(null);

    const handleFileChange = (event) => {
        if (event.target.files.length > 0) {
            const selectedFile = event.target.files[0];
            setFile(selectedFile);
            setFileName(selectedFile.name);
        }
    };

    const triggerFileInput = () => {
        fileInputRef.current.click();
    };

    const handleUpload = async () => {
        if (!file) {
            alert('Please select a file first!');
            return;
        }

        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await fetch('http://localhost:5000/upload', {
                method: 'POST',
                body: formData,
            });

            if (response.ok) {
                setUploadSuccess(true);
                setFile(null);
                setFileName('');
            } else {
                throw new Error('Failed to upload file');
            }
        } catch (error) {
            console.error('Error uploading file:', error);
            alert(error.message);
        }
    };

    return (
        <Box maxWidth="sm" sx={{ mt: 5, }}>
          

<Box sx={{display:'flex',justifyContent:'space-between'}}>
<Typography variant="h6" gutterBottom sx={{ textAlign: 'left' }}>
               Certificate
            </Typography>
            <Typography variant="h6" gutterBottom sx={{ textAlign: 'left' }}>
               + Add New
            </Typography>
</Box>

            <Box>
                <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                />
                <TextField
                    placeholder="Select a file..."
                    value={fileName}
                    onClick={triggerFileInput}
                    fullWidth
                    sx={{ mb: 2 }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={triggerFileInput} color="primary">
                                    <AttachFileIcon />
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
            </Box>
            <Box textAlign="right">
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleUpload}
                    disabled={!file}
                >
                    Upload
                </Button>
            </Box>
            {uploadSuccess && (
                <Typography color="success.main" sx={{ mt: 2 }}>
                    File uploaded successfully!
                </Typography>
            )}
        </Box>
    );
};
